const EMPTY_DECLINE_REASON = "—";

const DECLINE_STATUSES = new Set([
  "declined",
  "failed",
  "rejected",
  "canceled",
  "cancelled",
]);

export interface WithdrawalDeclineReasonSource {
  canonical_status?: string | null;
  status?: string | null;
  operatorDeclineReason?: string | null;
  providerMessage?: string | null;
  rejectionReason?: string | null;
}

const displayText = (value: unknown): string | null => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
};

const isDeclineStatus = (row: WithdrawalDeclineReasonSource): boolean => {
  const status = displayText(row.canonical_status) ?? displayText(row.status);
  return status != null && DECLINE_STATUSES.has(status.toLowerCase());
};

/**
 * Display text for one withdrawal decline reason.
 * A non-empty operatorDeclineReason is the saved manual back-office decline.
 * Automatic PSP declines use the provider reason already on the row.
 * The source object is not changed.
 */
export const displayedWithdrawalDeclineReason = (
  row: WithdrawalDeclineReasonSource | null | undefined,
): string => {
  const operatorReason = displayText(row?.operatorDeclineReason);
  if (operatorReason) return operatorReason;
  if (!row || !isDeclineStatus(row)) return EMPTY_DECLINE_REASON;
  return (
    displayText(row.providerMessage) ??
    displayText(row.rejectionReason) ??
    EMPTY_DECLINE_REASON
  );
};
